import axios from "axios";

import myConfig from "../configs/config";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

export async function fetchPluviometryMap(farmId, period, range = {}) {
  const params = {
    farm_id: farmId,
    period: period || "today",
  };
  if (period === "custom") {
    if (range.start) params.start = range.start;
    if (range.end) params.end = range.end;
  }
  const response = await axios.get(`${myConfig.API_URL}/mobile/pluviometry/map/`, {
    params,
    headers: authHeaders(),
  });
  return response.data;
}

export async function fetchPluviometerStations(farmId) {
  const response = await axios.get(`${myConfig.API_URL}/mobile/pluviometry/stations/`, {
    params: { farm_id: farmId },
    headers: authHeaders(),
  });
  return response.data;
}

export async function createPluviometerStation(farmId, payload) {
  const response = await axios.post(
    `${myConfig.API_URL}/mobile/pluviometry/stations/`,
    payload,
    {
      params: { farm_id: farmId },
      headers: authHeaders(),
    }
  );
  return response.data;
}

export async function fetchPluviometerRainSheet(farmId, stationUuid, year) {
  const response = await axios.get(
    `${myConfig.API_URL}/mobile/pluviometry/stations/${stationUuid}/sheet/`,
    {
      params: {
        farm_id: farmId,
        year: year,
      },
      headers: authHeaders(),
    }
  );
  return response.data;
}

export async function upsertPluviometerDailyReading(farmId, stationUuid, payload) {
  const response = await axios.put(
    `${myConfig.API_URL}/mobile/pluviometry/stations/${stationUuid}/daily/`,
    payload,
    {
      params: { farm_id: farmId },
      headers: authHeaders(),
    }
  );
  return response.data;
}

export async function updatePluviometerStation(farmId, stationUuid, payload) {
  const response = await axios.patch(
    `${myConfig.API_URL}/mobile/pluviometry/stations/${stationUuid}/`,
    payload,
    {
      params: { farm_id: farmId },
      headers: authHeaders(),
    }
  );
  return response.data;
}

export async function updatePluviometerReading(farmId, readingUuid, payload) {
  const response = await axios.patch(
    `${myConfig.API_URL}/mobile/pluviometry/readings/${readingUuid}/`,
    payload,
    {
      params: { farm_id: farmId },
      headers: authHeaders(),
    }
  );
  return response.data;
}

export async function deletePluviometerStation(farmId, stationUuid) {
  try {
    await axios.delete(
      `${myConfig.API_URL}/mobile/pluviometry/stations/${stationUuid}/`,
      {
        params: { farm_id: farmId },
        headers: authHeaders(),
      }
    );
  } catch (error) {
    const status = error.response && error.response.status;
    if (status === 405 || status === 404 || status === 501) {
      await axios.patch(
        `${myConfig.API_URL}/mobile/pluviometry/stations/${stationUuid}/`,
        { active: false },
        {
          params: { farm_id: farmId },
          headers: authHeaders(),
        }
      );
      return;
    }
    throw error;
  }
}
